/* Janizuka theme.js — minimal, framework-free */
(function () {
  'use strict';

  // --- Mobile nav toggle ---
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('.j-burger');
    if (burger) {
      var nav = document.querySelector('.j-nav');
      if (nav) {
        var isOpen = nav.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    }
  });

  // --- Filter chips (homepage / collection demo behaviour) ---
  document.querySelectorAll('[data-chip-group]').forEach(function (group) {
    var chips = group.querySelectorAll('.j-chip');
    var gridSel = group.getAttribute('data-target') || '.j-grid';
    var grid = document.querySelector(gridSel);
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
        chip.setAttribute('aria-pressed', 'true');
        var tag = chip.getAttribute('data-tag') || '';
        if (!grid) return;
        grid.querySelectorAll('.j-card').forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').toLowerCase();
          card.style.display = (!tag || tags.indexOf(tag.toLowerCase()) !== -1) ? '' : 'none';
        });
      });
    });
  });

  // --- In-page search (filters product cards by title/type/tags/collection text) ---
  document.querySelectorAll('[data-card-search]').forEach(function (control) {
    var input = control.matches('input, textarea') ? control : control.querySelector('[data-card-search-input], input[type="search"]');
    if (!input) return;

    var root = control.closest('section') || input.closest('section') || document;
    var gridSel = control.getAttribute('data-target') || input.getAttribute('data-target') || '[data-card-grid], .j-grid';
    var grid = document.querySelector(gridSel) || root.querySelector(gridSel);
    var count = root.querySelector('[data-card-count]');
    var empty = root.querySelector('[data-card-search-empty]');
    var clear = root.querySelector('[data-card-search-clear]');
    var label = count ? (count.getAttribute('data-card-count-label') || 'items') : 'items';

    function applySearch() {
      var q = input.value.toLowerCase().trim();
      var visible = 0;
      if (!grid) return;

      grid.querySelectorAll('.j-card').forEach(function (card) {
        var text = (card.getAttribute('data-search-text') || card.textContent || '').toLowerCase();
        var show = !q || text.indexOf(q) !== -1;
        card.style.display = show ? '' : 'none';
        if (show) visible += 1;
      });

      if (count) {
        count.textContent = visible + ' ' + label + (q ? ' shown' : '');
      }
      if (empty) {
        empty.hidden = !(q && visible === 0);
      }
      if (clear) {
        clear.hidden = !q;
      }
    }

    input.addEventListener('input', applySearch);
    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        input.focus();
        applySearch();
      });
    }
    applySearch();
  });

  // --- PDP gallery thumbs ---
  document.querySelectorAll('[data-pdp-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-pdp-main]');
    var thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); t.setAttribute('aria-selected', 'false'); t.classList.remove('is-active'); });
        thumb.setAttribute('aria-current', 'true');
        thumb.setAttribute('aria-selected', 'true');
        thumb.classList.add('is-active');
        var src = thumb.getAttribute('data-src');
        var srcset = thumb.getAttribute('data-srcset');
        var alt = thumb.getAttribute('data-alt');
        if (main && src) {
          var img = main.querySelector('img');
          if (img) {
            img.src = src;
            if (srcset) img.srcset = srcset;
            if (alt) img.alt = alt;
          }
        }
      });
    });
  });

  // --- PDP quantity stepper ---
  document.querySelectorAll('.j-pdp__qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    var buttons = qty.querySelectorAll('button');
    if (!input || buttons.length < 2) return;
    buttons[0].addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    buttons[1].addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  // --- PDP variant picker ---
  // Keeps the visible option buttons, hidden Shopify variant ID, price and add-to-cart button in sync.
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantInput = form.querySelector('[data-variant-input], input[name="id"]');
    var variantJson = form.querySelector('[data-product-variants]');
    var addButton = form.querySelector('[data-add-button], button[type="submit"]');
    var addLabel = form.querySelector('[data-add-label]');
    var addPrice = form.querySelector('[data-add-price]');
    var productRoot = form.closest('.j-pdp') || form.closest('section') || document;
    var priceEl = productRoot.querySelector('[data-product-price], .j-pdp__price');
    var optionGroups = Array.prototype.slice.call(form.querySelectorAll('[data-option-position], [data-variant-group]'));
    var variants = [];

    if (!variantInput || !variantJson || !optionGroups.length) return;

    try {
      variants = JSON.parse(variantJson.textContent || '[]');
    } catch (err) {
      return;
    }

    function selectedOptions() {
      return optionGroups.map(function (group) {
        var active = group.querySelector('.j-pdp__swatch.is-active, .j-pdp__swatch[aria-pressed="true"]');
        var first = group.querySelector('.j-pdp__swatch');
        return active ? getSwatchValue(active) : (first ? getSwatchValue(first) : '');
      });
    }

    function getSwatchValue(swatch) {
      return swatch.getAttribute('data-option-value') || swatch.getAttribute('data-value') || swatch.textContent.trim();
    }

    function findVariant(options) {
      return variants.find(function (variant) {
        if (!variant.options || variant.options.length !== options.length) return false;
        return variant.options.every(function (value, index) { return value === options[index]; });
      });
    }

    function setActiveSwatch(group, selectedSwatch) {
      group.querySelectorAll('.j-pdp__swatch').forEach(function (swatch) {
        var isActive = swatch === selectedSwatch;
        swatch.classList.toggle('is-active', isActive);
        swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      var currentLabel = group.querySelector('[data-option-current]');
      if (currentLabel) currentLabel.textContent = getSwatchValue(selectedSwatch);
    }

    function updatePrice(variant) {
      if (!priceEl || !variant) return;
      priceEl.innerHTML = variant.compare_at_price
        ? '<span class="j-price">' + variant.price + '<s>' + variant.compare_at_price + '</s></span>'
        : '<span class="j-price">' + variant.price + '</span>';
    }

    function updateAddButton(variant) {
      if (!addButton || !variant) return;

      if (variant.available) {
        addButton.disabled = false;
        addButton.removeAttribute('aria-disabled');
        if (addLabel) addLabel.textContent = addLabel.getAttribute('data-default-label') || addLabel.textContent || 'Add to bag';
        if (addPrice) addPrice.textContent = variant.price;
      } else {
        addButton.disabled = true;
        addButton.setAttribute('aria-disabled', 'true');
        if (addLabel) addLabel.textContent = 'Sold out';
        if (addPrice) addPrice.textContent = '';
      }
    }

    function syncOptionAvailability() {
      var current = selectedOptions();

      optionGroups.forEach(function (group, groupIndex) {
        group.querySelectorAll('.j-pdp__swatch').forEach(function (swatch) {
          var candidate = current.slice();
          candidate[groupIndex] = getSwatchValue(swatch);
          var possible = variants.some(function (variant) {
            return variant.options && variant.options.every(function (value, index) {
              return !candidate[index] || candidate[index] === value;
            });
          });

          swatch.disabled = !possible;
          swatch.classList.toggle('is-unavailable', !possible);
          swatch.setAttribute('aria-disabled', possible ? 'false' : 'true');
        });
      });
    }

    function syncVariant() {
      var variant = findVariant(selectedOptions());
      if (!variant) {
        if (addButton) {
          addButton.disabled = true;
          addButton.setAttribute('aria-disabled', 'true');
        }
        return;
      }

      variantInput.value = variant.id;
      updatePrice(variant);
      updateAddButton(variant);
      syncOptionAvailability();
      form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    // Preserve the original add-to-cart wording, so it can be restored after selecting an available variant.
    if (addLabel && !addLabel.getAttribute('data-default-label')) {
      addLabel.setAttribute('data-default-label', addLabel.textContent.trim() || 'Add to bag');
    }

    optionGroups.forEach(function (group) {
      group.querySelectorAll('.j-pdp__swatch').forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          if (swatch.disabled) return;
          setActiveSwatch(group, swatch);
          syncVariant();
        });
      });
    });

    syncVariant();
  });
})();

/* Category carousel / grouped collection page behaviour */
(function () {
  'use strict';

  function activeValue(buttons, attr, fallback) {
    var active = buttons.find(function (button) { return button.getAttribute('aria-pressed') === 'true'; });
    return active ? (active.getAttribute(attr) || fallback) : fallback;
  }

  function getCarouselPageSize(carousel) {
    var row = carousel.closest('[data-category-row]');
    var root = carousel.closest('[data-category-collection], [data-list-collections]');
    var raw = (row && row.getAttribute('data-row-page-size')) ||
      (root && root.getAttribute('data-carousel-page-size')) ||
      '24';
    var size = parseInt(raw, 10);
    return size > 0 ? size : 24;
  }

  function getCarouselCards(carousel) {
    var track = carousel.querySelector('[data-category-track]');
    return track ? Array.prototype.slice.call(track.querySelectorAll('[data-category-card]')) : [];
  }

  function getCarouselPageInfo(carousel) {
    var track = carousel.querySelector('[data-category-track]');
    if (!track) return null;

    var pageSize = getCarouselPageSize(carousel);
    var cards = getCarouselCards(carousel);
    var visibleCards = cards.filter(function (card) {
      return card.getAttribute('data-filter-visible') !== 'false';
    });
    var totalPages = Math.max(1, Math.ceil(visibleCards.length / pageSize));
    var currentPageIndex = parseInt(carousel.getAttribute('data-current-page'), 10) || 0;
    currentPageIndex = Math.min(totalPages - 1, Math.max(0, currentPageIndex));
    carousel.setAttribute('data-current-page', String(currentPageIndex));

    return {
      track: track,
      cards: cards,
      visibleCards: visibleCards,
      pageSize: pageSize,
      totalPages: totalPages,
      currentPageIndex: currentPageIndex,
      currentPage: currentPageIndex + 1,
      totalVisible: visibleCards.length
    };
  }

  function renderCarouselPage(carousel, requestedPageIndex) {
    if (typeof requestedPageIndex === 'number' && isFinite(requestedPageIndex)) {
      carousel.setAttribute('data-current-page', String(Math.max(0, requestedPageIndex)));
    }

    var info = getCarouselPageInfo(carousel);
    if (!info) return;

    var visibleIndex = 0;
    info.cards.forEach(function (card) {
      var filterVisible = card.getAttribute('data-filter-visible') !== 'false';
      var showOnPage = false;

      if (filterVisible) {
        showOnPage = Math.floor(visibleIndex / info.pageSize) === info.currentPageIndex;
        visibleIndex += 1;
      }

      card.hidden = !showOnPage;
      card.classList.toggle('is-hidden', !showOnPage);
      card.setAttribute('aria-hidden', showOnPage ? 'false' : 'true');
    });

    // Each visual page starts from the left edge, while the visible 24 products
    // remain in the same horizontal carousel format.
    info.track.scrollLeft = 0;
    syncCarouselButtons(carousel);
  }

  function syncCarouselPagination(carousel) {
    var row = carousel.closest('[data-category-row]');
    var pagination = row ? row.querySelector('[data-row-pagination]') : null;
    var info = getCarouselPageInfo(carousel);
    if (!pagination || !info) return;

    var status = pagination.querySelector('[data-row-page-status]');
    var buttonsWrap = pagination.querySelector('[data-row-page-buttons]');
    var hasMultiplePages = info.totalPages > 1;

    pagination.hidden = !hasMultiplePages;
    if (!hasMultiplePages) {
      if (buttonsWrap) {
        buttonsWrap.innerHTML = '';
        buttonsWrap.removeAttribute('data-page-count');
      }
      if (status) status.textContent = '';
      return;
    }

    if (status) {
      var start = ((info.currentPage - 1) * info.pageSize) + 1;
      var end = Math.min(info.currentPage * info.pageSize, info.totalVisible);
      status.textContent = 'Page ' + info.currentPage + ' of ' + info.totalPages + ' · Items ' + start + '–' + end;
    }

    if (!buttonsWrap) return;
    if (buttonsWrap.getAttribute('data-page-count') !== String(info.totalPages)) {
      buttonsWrap.innerHTML = '';
      buttonsWrap.setAttribute('data-page-count', String(info.totalPages));

      for (var i = 1; i <= info.totalPages; i += 1) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'j-carousel-page';
        button.setAttribute('data-row-page', String(i - 1));
        button.setAttribute('aria-label', 'Show carousel page ' + i);
        button.textContent = String(i);
        buttonsWrap.appendChild(button);
      }
    }

    buttonsWrap.querySelectorAll('[data-row-page]').forEach(function (button, index) {
      var isCurrent = index === info.currentPageIndex;
      button.setAttribute('aria-current', isCurrent ? 'true' : 'false');
    });
  }

  function syncCarouselButtons(carousel) {
    var prev = carousel.querySelector('[data-row-prev]');
    var next = carousel.querySelector('[data-row-next]');
    var info = getCarouselPageInfo(carousel);
    if (!info) return;

    var maxScroll = Math.max(0, info.track.scrollWidth - info.track.clientWidth);
    var canScrollLeft = info.track.scrollLeft > 2;
    var canScrollRight = info.track.scrollLeft < (maxScroll - 2);
    var hasPreviousProductPage = info.currentPageIndex > 0;
    var hasNextProductPage = info.currentPageIndex < (info.totalPages - 1);

    if (prev) {
      prev.disabled = !canScrollLeft && !hasPreviousProductPage;
    }
    if (next) {
      next.disabled = !canScrollRight && !hasNextProductPage;
    }

    syncCarouselPagination(carousel);
  }

  function scrollCarouselToPage(carousel, pageIndex) {
    renderCarouselPage(carousel, pageIndex);
  }

  function scrollTrack(carousel, direction) {
    var info = getCarouselPageInfo(carousel);
    if (!info) return;

    var maxScroll = Math.max(0, info.track.scrollWidth - info.track.clientWidth);
    var scrollAmount = Math.max(220, Math.floor(info.track.clientWidth * 0.9));

    if (direction > 0) {
      if (info.track.scrollLeft < (maxScroll - 2)) {
        info.track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        window.setTimeout(function () { syncCarouselButtons(carousel); }, 360);
      } else if (info.currentPageIndex < (info.totalPages - 1)) {
        renderCarouselPage(carousel, info.currentPageIndex + 1);
      }
      return;
    }

    if (info.track.scrollLeft > 2) {
      info.track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      window.setTimeout(function () { syncCarouselButtons(carousel); }, 360);
    } else if (info.currentPageIndex > 0) {
      renderCarouselPage(carousel, info.currentPageIndex - 1);
      window.setTimeout(function () {
        var updatedInfo = getCarouselPageInfo(carousel);
        if (!updatedInfo) return;
        updatedInfo.track.scrollLeft = Math.max(0, updatedInfo.track.scrollWidth - updatedInfo.track.clientWidth);
        syncCarouselButtons(carousel);
      }, 0);
    }
  }

  function buildCategoryChips(root, rows) {
    // Auto-generate the top category chips from the Category row blocks, so adding,
    // removing or renaming a row in the theme editor updates this bar automatically.
    var bar = root.querySelector('[data-category-filter-bar]');
    if (!bar) return;
    rows.forEach(function (row) {
      var slug = row.getAttribute('data-category') || '';
      if (!slug) return;
      if (bar.querySelector('[data-category-filter="' + slug + '"]')) return;
      var label = row.getAttribute('data-chip-label');
      if (!label) {
        var title = row.querySelector('h2');
        label = title ? title.textContent.trim() : slug;
      }
      var chip = document.createElement('button');
      chip.className = 'j-chip';
      chip.type = 'button';
      chip.setAttribute('aria-pressed', 'false');
      chip.setAttribute('data-category-filter', slug);
      chip.textContent = label;
      bar.appendChild(chip);
    });
  }

  function initCategoryCollection(root) {
    var stockButtons = Array.prototype.slice.call(root.querySelectorAll('[data-stock-filter]'));
    var search = root.querySelector('[data-category-search]');
    var clearSearch = root.querySelector('[data-category-search-clear]');
    var count = root.querySelector('[data-category-count]');
    var empty = root.querySelector('[data-category-empty]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-category-row]'));
    var categorySelect = root.querySelector('[data-mobile-category-select]');
    var stockSelect = root.querySelector('[data-mobile-stock-select]');

    buildCategoryChips(root, rows);
    var categoryButtons = Array.prototype.slice.call(root.querySelectorAll('[data-category-filter]'));

    function termsMatch(text, terms) {
      if (!terms) return true;
      return terms.split(',').some(function (term) {
        term = term.trim().toLowerCase();
        return term && text.indexOf(term) !== -1;
      });
    }

    function applyFilters() {
      var activeCategory = activeValue(categoryButtons, 'data-category-filter', 'all');
      var activeStock = activeValue(stockButtons, 'data-stock-filter', 'all');
      var query = search ? search.value.trim().toLowerCase() : '';
      var visibleCards = 0;
      var visibleRows = 0;

      if (categorySelect && categorySelect.value !== activeCategory) {
        categorySelect.value = activeCategory;
      }
      if (stockSelect && stockSelect.value !== activeStock) {
        stockSelect.value = activeStock;
      }

      rows.forEach(function (row) {
        var rowCategory = row.getAttribute('data-category') || '';
        var categoryMatches = activeCategory === 'all' || rowCategory === activeCategory;
        var rowVisibleCards = 0;
        var activeSubcategory = row.getAttribute('data-active-subcategory') || '';
        var cards = Array.prototype.slice.call(row.querySelectorAll('[data-category-card]'));

        cards.forEach(function (card) {
          var stock = card.getAttribute('data-stock') || '';
          var text = card.getAttribute('data-search-text') || card.textContent.toLowerCase();
          var stockMatches = activeStock === 'all' || stock.indexOf(activeStock) !== -1;
          var searchMatches = !query || text.indexOf(query) !== -1;
          var subcategoryMatches = termsMatch(text, activeSubcategory);
          var show = categoryMatches && stockMatches && searchMatches && subcategoryMatches;
          card.setAttribute('data-filter-visible', show ? 'true' : 'false');
          if (show) {
            rowVisibleCards += 1;
            visibleCards += 1;
          }
        });

        var rowEmpty = row.querySelector('[data-row-empty]');
        var rowFilterActive = !!query || activeStock !== 'all' || !!activeSubcategory;
        var rowShouldShow = categoryMatches && (!rowFilterActive || rowVisibleCards > 0 || activeCategory === rowCategory);
        row.hidden = !rowShouldShow;
        if (rowEmpty) rowEmpty.hidden = !(rowShouldShow && rowVisibleCards === 0);
        if (rowShouldShow) visibleRows += 1;

        var carousel = row.querySelector('[data-category-carousel]');
        if (carousel) {
          renderCarouselPage(carousel, 0);
        }
      });

      if (count) {
        count.textContent = visibleCards + (visibleCards === 1 ? ' item shown' : ' items shown');
      }
      if (empty) {
        empty.hidden = visibleCards !== 0;
      }
      if (clearSearch) {
        clearSearch.hidden = !query;
      }
    }

    root.querySelectorAll('[data-subcategory-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        // Scope to the nearest category row so nested filter blocks work without a row id.
        var row = button.closest('[data-category-row]');
        if (!row) return;
        var value = button.getAttribute('data-subcategory-filter') || '';
        row.querySelectorAll('[data-subcategory-filter]').forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
        button.setAttribute('aria-pressed', 'true');
        row.setAttribute('data-active-subcategory', value);
        var select = row.querySelector('[data-mobile-subcategory-select]');
        if (select && select.value !== value) select.value = value;
        applyFilters();
      });
    });

    root.querySelectorAll('[data-mobile-subcategory-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        var row = select.closest('[data-category-row]');
        if (!row) return;
        var value = select.value || '';
        row.querySelectorAll('[data-subcategory-filter]').forEach(function (button) {
          button.setAttribute('aria-pressed', (button.getAttribute('data-subcategory-filter') || '') === value ? 'true' : 'false');
        });
        row.setAttribute('data-active-subcategory', value);
        applyFilters();
      });
    });

    categoryButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        categoryButtons.forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
        button.setAttribute('aria-pressed', 'true');
        if (categorySelect) categorySelect.value = button.getAttribute('data-category-filter') || 'all';
        applyFilters();
      });
    });

    if (categorySelect) {
      categorySelect.addEventListener('change', function () {
        var value = categorySelect.value || 'all';
        categoryButtons.forEach(function (button) {
          button.setAttribute('aria-pressed', (button.getAttribute('data-category-filter') || 'all') === value ? 'true' : 'false');
        });
        applyFilters();
      });
    }

    stockButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        stockButtons.forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
        button.setAttribute('aria-pressed', 'true');
        if (stockSelect) stockSelect.value = button.getAttribute('data-stock-filter') || 'all';
        applyFilters();
      });
    });

    if (stockSelect) {
      stockSelect.addEventListener('change', function () {
        var value = stockSelect.value || 'all';
        stockButtons.forEach(function (button) {
          button.setAttribute('aria-pressed', (button.getAttribute('data-stock-filter') || 'all') === value ? 'true' : 'false');
        });
        applyFilters();
      });
    }

    if (search) {
      search.addEventListener('input', applyFilters);
    }

    if (clearSearch && search) {
      clearSearch.addEventListener('click', function () {
        search.value = '';
        search.focus();
        applyFilters();
      });
    }

    root.addEventListener('click', function (event) {
      var page = event.target.closest('[data-row-page]');
      if (page) {
        var pageRow = page.closest('[data-category-row]');
        var pageCarousel = pageRow ? pageRow.querySelector('[data-category-carousel]') : null;
        if (pageCarousel) scrollCarouselToPage(pageCarousel, parseInt(page.getAttribute('data-row-page'), 10) || 0);
        return;
      }

      var prev = event.target.closest('[data-row-prev]');
      var next = event.target.closest('[data-row-next]');
      if (!prev && !next) return;
      var carousel = event.target.closest('[data-category-carousel]');
      if (!carousel) return;
      scrollTrack(carousel, next ? 1 : -1);
    });

    root.querySelectorAll('[data-category-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-category-track]');
      if (track) track.addEventListener('scroll', function () { syncCarouselButtons(carousel); }, { passive: true });
      getCarouselCards(carousel).forEach(function (card) {
        if (!card.hasAttribute('data-filter-visible')) card.setAttribute('data-filter-visible', 'true');
      });
      renderCarouselPage(carousel, 0);
    });

    window.addEventListener('resize', function () {
      root.querySelectorAll('[data-category-carousel]').forEach(function (carousel) { renderCarouselPage(carousel); });
    }, { passive: true });

    applyFilters();
  }

  function initListCollections(root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-list-filter]'));
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-list-row]'));

    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        buttons.forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
        button.setAttribute('aria-pressed', 'true');
        var value = button.getAttribute('data-list-filter') || 'all';
        rows.forEach(function (row) {
          var show = value === 'all' || row.getAttribute('data-list-category') === value;
          row.hidden = !show;
          if (show) {
            row.querySelectorAll('[data-category-carousel]').forEach(function (carousel) { renderCarouselPage(carousel, 0); });
          }
        });
      });
    });

    root.addEventListener('click', function (event) {
      var page = event.target.closest('[data-row-page]');
      if (page) {
        var pageRow = page.closest('[data-category-row]');
        var pageCarousel = pageRow ? pageRow.querySelector('[data-category-carousel]') : null;
        if (pageCarousel) scrollCarouselToPage(pageCarousel, parseInt(page.getAttribute('data-row-page'), 10) || 0);
        return;
      }

      var prev = event.target.closest('[data-row-prev]');
      var next = event.target.closest('[data-row-next]');
      if (!prev && !next) return;
      var carousel = event.target.closest('[data-category-carousel]');
      if (!carousel) return;
      scrollTrack(carousel, next ? 1 : -1);
    });

    root.querySelectorAll('[data-category-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-category-track]');
      if (track) track.addEventListener('scroll', function () { syncCarouselButtons(carousel); }, { passive: true });
      getCarouselCards(carousel).forEach(function (card) {
        if (!card.hasAttribute('data-filter-visible')) card.setAttribute('data-filter-visible', 'true');
      });
      renderCarouselPage(carousel, 0);
    });

    window.addEventListener('resize', function () {
      root.querySelectorAll('[data-category-carousel]').forEach(function (carousel) { renderCarouselPage(carousel); });
    }, { passive: true });
  }

  document.querySelectorAll('[data-category-collection]').forEach(initCategoryCollection);
  document.querySelectorAll('[data-list-collections]').forEach(initListCollections);
})();


/* Instagram community filters + bottom newsletter popup */
(function () {
  'use strict';

  document.querySelectorAll('[data-insta-filter-group]').forEach(function (group) {
    var target = document.querySelector(group.getAttribute('data-target'));
    var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-insta-filter]'));
    if (!target) return;
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var selected = button.getAttribute('data-insta-filter') || 'all';
        buttons.forEach(function (item) { item.setAttribute('aria-pressed', 'false'); });
        button.setAttribute('aria-pressed', 'true');
        target.querySelectorAll('[data-insta-category]').forEach(function (reel) {
          var category = reel.getAttribute('data-insta-category') || '';
          reel.hidden = !(selected === 'all' || category === selected);
        });
      });
    });
  });

  var popup = document.querySelector('[data-newsletter-popup]');
  if (!popup) return;
  var key = 'janizukaNewsletterPopupDismissedUntil';
  var now = Date.now();
  var dismissedUntil = parseInt(localStorage.getItem(key) || '0', 10);
  if (dismissedUntil && dismissedUntil > now) return;

  function dismissPopup() {
    var days = parseInt(popup.getAttribute('data-days') || '14', 10);
    localStorage.setItem(key, String(Date.now() + days * 24 * 60 * 60 * 1000));
    popup.classList.remove('is-visible');
    window.setTimeout(function () { popup.hidden = true; }, 260);
  }

  window.setTimeout(function () {
    popup.hidden = false;
    requestAnimationFrame(function () { popup.classList.add('is-visible'); });
  }, Math.max(0, parseInt(popup.getAttribute('data-delay') || '4', 10)) * 1000);

  popup.querySelectorAll('[data-newsletter-close]').forEach(function (button) {
    button.addEventListener('click', dismissPopup);
  });
  popup.querySelectorAll('form').forEach(function (form) {
    form.addEventListener('submit', function () {
      localStorage.setItem(key, String(Date.now() + 90 * 24 * 60 * 60 * 1000));
    });
  });
})();
